import '../../../plugins/omChosen/chosen/chosen.jquery.js';
import 'bootstrap/dist/js/bootstrap.js';
import '../../../plugins/bozp/js/datepicker.min.js';
import '../../../plugins/bozp/js/validator.min.js';
import '../../../plugins/bozp/src/member/member.min.js';
import './Toggler.js';
import 'moment/moment.js';
import 'moment/locale/cs.js';
import 'pikaday/pikaday.js';
import 'bootstrap-validator/dist/validator.js';

(function ($) {
	return $(document).ready(function () {
		return $('[data-toggle=tooltip]').tooltip();
	});
})(jQuery);
